import * as React from 'react';
import { IGroupedComboBoxButtonLabelProps } from 'grouped-combobox-web';

export default function renderLabelWithOwnFont(
    props: IGroupedComboBoxButtonLabelProps
): React.ReactNode {
    const { item, labelClassName, theme } = props;
    const label = item.displayText ?? item.text;

    const themeFont = theme?.fonts?.medium.fontFamily;

    // For organization font, we don't have the preview glyph.
    // So we render it with the font name itself, and fall
    // back to theme font (i.e. Segoe UI) if not available
    const fontFamily = themeFont ? `'${label}', ${themeFont}` : `'${label}'`;

    const styles = {
        fontFamily: fontFamily,
    };

    return (
        <span className={labelClassName} style={styles}>
            {label}
        </span>
    );
}
